import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { FinancialDocumentListItem } from "@common/types/financialDocument";
import { User } from "@common/types/user";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import {
    getUploaderLabel,
    renderUploaderIcon,
    findIntegrationBySource,
} from "../../uploaderHelpers";

export const UploaderCell = memo(
    ({
        row,
    }: CellContext<
        ViewTableFeatures,
        FinancialDocumentListItem,
        User | null
    >) => {
        const { uploader, source } = row.original;
        const integration = findIntegrationBySource(source);

        return (
            <ViewTableCell>
                <Tooltip content={getUploaderLabel(uploader, integration)}>
                    <span>{renderUploaderIcon(uploader, integration)}</span>
                </Tooltip>
            </ViewTableCell>
        );
    },
);
